import * as React from 'react';
import { useEffect, useState } from 'react';
import useFetch from 'use-http';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import CheckRegisterBNoticeItem from 'src/models/personnel/CheckRegisterBNoticeItem';
import { ODataOptions } from 'src/util/ODataBuilder';

interface ICheckRegisterBNoticeDialogProps {
    dialogName: string;
    hideDialog: () => void;
}

const formatDate = (value: Date | string): string => {
    if (!value) {
        return '';
    }
    const date = new Date(value);
    return isNaN(date.getTime()) ? '' : date.toLocaleDateString();
};

// Mirrors Check_Register_BNotice (opened by the main screen's "B-Notice With" button) - checks
// with a withholding line item whose description matches '%B-Notice%' in `check_register_withhold`,
// joined back to CHECK_REGISTER for period/paid-to/check-date/void.
const CheckRegisterBNoticeDialog = (props: ICheckRegisterBNoticeDialogProps) => {
    const { get, response } = useFetch();
    const [rows, setRows] = useState<Array<CheckRegisterBNoticeItem>>([]);

    useEffect(() => {
        const fetchBNotice = async () => {
            const options = new ODataOptions().addSkipTop(0, 50);
            const result = await get(`/v1.0/Payroll/bnotice${options.toString()}`);
            if (response.ok) {
                setRows(result?.items ?? []);
            }
        };
        fetchBNotice();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const totalAmount = rows.reduce((sum, row) => sum + (row.amount ?? 0), 0);

    return (
        <Dialog title="B-Notice Withholding" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '55%' }}>
            <div style={{ maxHeight: '25rem', overflowY: 'auto' }}>
                <table style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th>DLC No.</th>
                            <th>Period No.</th>
                            <th>Check No.</th>
                            <th>Check Date</th>
                            <th>Paid To</th>
                            <th>Amount</th>
                            <th>Void?</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, index) => (
                            <tr key={index}>
                                <td>{row.tsdNo}</td>
                                <td>{row.periodNo}</td>
                                <td>{row.checkNo}</td>
                                <td>{formatDate(row.checkDate)}</td>
                                <td>{row.paidTo}</td>
                                <td style={{ textAlign: 'right' }}>{(row.amount ?? 0).toFixed(2)}</td>
                                <td>{row.void}</td>
                            </tr>
                        ))}
                        {rows.length === 0 && (
                            <tr><td colSpan={7} className="bold-centered">No B-Notice Checks</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div className="form-row" style={{ justifyContent: 'flex-end', marginTop: '1rem' }}>
                <label>Total Amount: {totalAmount.toFixed(2)}</label>
            </div>
            <div className="form-row" style={{ marginTop: '1rem', justifyContent: 'center' }}>
                <Button className="blue-hover-button" style={{ width: '20%' }} text="Back" onClick={() => props.hideDialog()} />
            </div>
        </Dialog>
    );
};

export default CheckRegisterBNoticeDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/checkRegister/CheckRegisterBNoticeDialog.tsx